import React from "react";
import { useAuth } from "../contexts/AuthContext";
import CoachSettings from "./CoachSettings";
import ParentSettings from "./ParentSettings";

/**
 * Routes /settings to the right page based on role.
 *  - coach   → full coach settings (4 tabs)
 *  - parent  → parent settings (profile/preferences/location)
 *  - player  → fallback to parent layout
 *  - academy → CoachSettings (will get its own page in Iter 11)
 */
export default function SettingsRouter() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "parent" || user.role === "player") return <ParentSettings />;
  return <CoachSettings />;
}
